import type { AdvertisingTypes, IApiResponse } from "@litres-libs/types";
import { getCookie } from "@litres/utils";
import { rtkqApi } from "../api/rtkqApi";

const sessionId = getCookie("SID");

export const advertisingBannersApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getBanners: build.query<
      AdvertisingTypes.BannerResponse[],
      { place: AdvertisingTypes.BannerPlaceSlugChoices; isPDA?: boolean }
    >({
      query: ({ place, isPDA }) => {
        return {
          url: `/advertising/api/services/litres/places/${place}/banners`,
          params: {
            device_type: isPDA ? "mobile" : "default",
          },
          method: "GET",
        };
      },
      transformResponse: (
        response: IApiResponse<AdvertisingTypes.BannerResponse[]>
      ) => {
        return response.payload.data;
      },
    }),
    getGenreBanners: build.query<
      AdvertisingTypes.BannerResponse[],
      {
        place: AdvertisingTypes.BannerPlaceSlugChoices;
        genreId: number;
        isPDA?: boolean;
      }
    >({
      query: ({ place, genreId, isPDA }) => ({
        url: `/advertising/api/services/litres/places/${place}/genres/${genreId}/banners`,
        method: "GET",
        params: {
          device_type: isPDA ? "mobile" : "default",
        },
        headers: {
          "Session-Id": `${sessionId}`,
        },
      }),
      transformResponse: (
        response: IApiResponse<AdvertisingTypes.BannerResponse[]>
      ) => {
        return response.payload.data;
      },
    }),
  }),
});
